import React from "react"
import styles from "./styles.scss"
import ProcessStep from "./ProcessStep"
import cx from "classnames"

class MobileChart extends React.Component {
  render() {
    return (
      <section
        className={cx(styles.container, { [styles.ie]: this.props.isIE })}
      >
        <div className={styles.wrapper}>
          {this.props.processSteps.map(step => (
            <ProcessStep key={step.id} processStep={step} />
          ))}
        </div>
      </section>
    )
  }
}

export default MobileChart



// WEBPACK FOOTER //
// ./src/pages/LandingPage/MobileChart/index.jsx